import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import Link from '@active/react-ui/Link'

import I18nMessage from '../../common/I18nMessage'
import SideTypeList, { KeycloakSideTypeList } from '../SideTypeListConf'
import './Sidebar.scss'
import connectLocale from '../../../shared/utils/connectLocale'
import { buildSafeQueryString } from '../../../shared/utils/commonUtils'

function handleCookieSettingClick() {
  const cookieSetting = document.querySelector('.optanon-show-settings-container>button')
  if (cookieSetting && cookieSetting.click) {
    cookieSetting.click()
  }
}
class Sidebar extends PureComponent {
  static propTypes = {
    locale: string.isRequired,
    keycloakAPIServerHost: string.isRequired,
    passportAPIServerHost: string.isRequired,
    sideType: string.isRequired,
  }

  handleArrowClick = () => {
    const target = this.sidebar
    if (target.classList.contains('move-left')) {
      target.classList.remove('move-left')
      target.classList.add('move-right')
    } else {
      target.classList.remove('move-right')
      target.classList.add('move-left')
    }
  }

  render() {
    const {
      passportAPIServerHost, keycloakAPIServerHost, locale, sideType,
    } = this.props
    const localeParam = buildSafeQueryString(locale)
    return (
      <div className="passport-ui-component__sidebar" ref={b => { this.sidebar = b }}>
        <div className="sidebar-normal">
          {
            SideTypeList.map(type => (
              <Link
                href={`${passportAPIServerHost}/page/account/${type}${localeParam}`}
                className={`passport__sidebar-item${sideType === type ? ' passport__sidebar-item-current' : ''}`}
                key={`a_${type}`}
              >
                <span className="icon-caret-right" />
                <I18nMessage id={`passport.${type}.title`} />
              </Link>
            ))
          }
          {
            KeycloakSideTypeList.map(type => (
              <Link
                href={`${keycloakAPIServerHost}/auth/realms/active/personal/${type}${localeParam}`}
                className={`passport__sidebar-item${sideType === type ? ' passport__sidebar-item-current' : ''}`}
                key={`a_${type}`}
              >
                <span className="icon-caret-right" />
                <I18nMessage id={`passport.${type}.title`} />
              </Link>
            ))
          }
          <Link
            onClick={handleCookieSettingClick}
            className="passport__sidebar-item passport__sidebar-cookie-setting"
          >
            <span className="icon-caret-right" />
            <I18nMessage id="passport.cookie.setting.title" />
          </Link>
        </div>
        <div className="passport__sidebar-arrow">
          <i className="ic-angle-left" onClick={this.handleArrowClick} />
        </div>
      </div>
    )
  }
}

export default connectLocale(Sidebar)
